import Link from 'components/Link'

import s from './ApplyOpenCallChoice.module.css'

const slugify = text =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text

function ApplyOpenCallChoice() {
  const renderSite = site => (
    <Link
      type='Apply'
      href={`open-call/${slugify(site)}`}
      key={site}
      className={s.agency}
    >
      {site}
    </Link>
  )

  return (
    <div className={s.container}>
      <h2 className={s.title}>Open Call</h2>
      <p className={s.text}>
        Some of our offices are currently not holding open calls and walk-ins. Please apply online or follow the local
        links below for detailed information
      </p>
      {['Chicago', 'London', 'Los Angeles', 'Stockholm'].map(renderSite)}
    </div>
  )
}

export default ApplyOpenCallChoice
